import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
	wrapper: {
		borderTop: '1px solid #d2d2d2',
		margin: '10px 20px 25px',
	},
	title: {
		color: '#999',
		fontSize: '14px',
		margin: '25px 0 20px',
		textTransform: 'uppercase',
		lineHeight: '1',
	},
	point: {
		borderRadius: '50%',
		width: '12px',
		height: '12px',
		marginTop: '4px',
		marginRight: '7px',
		display: 'inline-block',
	},
	text: {
		fontSize: '14px',
		marginRight: '7px',
		wordWrap: 'break-word',
		whiteSpace: 'normal',
		opacity: 0.9,
	},
};

class ReportChartLegend extends React.Component {
	render() {
		const {
			classes,
			customLegend = [],
		} = this.props;

		return (
			<div className={classes.wrapper}>
				<div className={classes.title}>Legend</div>
				{
					customLegend.map(({ color, text }, index) => {
						return (
							<React.Fragment key={index}>
								<span
									className={classes.point}
									style={{ backgroundColor: color }}
								></span>
								<span className={classes.text}>{text}</span>
							</React.Fragment>
						)
					})
				}
			</div>
		);
	}
}

export default withStyles(styles)(ReportChartLegend);
